<template>
  <div class="ticket-create">
    <page-title
      heading="ارسال تیکت پشتیبانی"
      subHeading="تیکت خود را از طریق اطلاعات زیر تکمیل و ارسال کنید."
      buttonTitle="بازگشت"
      @onClickButton="onClickBack"
    />
    <div class="card-wrapper">
      <form-details ref="formDetails" />
    </div>
    <div class="card-wrapper">
      <form-content ref="formContent" :titleVisible="true" />
    </div>
    <div class="card-wrapper">
      <attachments ref="formAttachments" title="ضمیمه ها" />
    </div>
    <vs-row class="button">
      <vs-button @click="submit">
        {{ "ارسال" }}
      </vs-button>
      <vs-button @click="onClickBack" color="#EA5455" class="ml-5">
        {{ "لغو" }}
      </vs-button>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import PageTitle from "../../../components/pageTitle/PageTitle.vue";
import Attachments from "../form/Attachments.vue";
import FormContent from "../form/FormContent.vue";
import FormDetails from "../form/FormDetails.vue";
import providerApiService from "../../../services/api/ProviderApiService";

export default {
  name: "Create.vue",
  components: { FormDetails, FormContent, Attachments, PageTitle },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {
    submit() {
      /**
       * Get the form data and attachments
       */
      const details = this.$refs["formDetails"].getData();
      const content = this.$refs["formContent"].getData();
      const attachments = this.$refs["formAttachments"].getData();

      /**
       * Send request to server with given data
       */
      this.$vs.loading();
      providerApiService
        .postCreateOrEditTicket({
          providerId: this.currentProvider.id,
          title: content.title,
          content: content.content,
          department: details.department.id,
          priority: details.priority.id,
          attachments,
        })
        .then(() => {
          this.$vs.notify({
            text: "عملیات با موفقیت انجام شد.",
            color: "success",
            position: "bottom-center",
          });
          this.onClickBack();
        })
        .finally(() => this.$vs.loading.close());
    },
    onClickBack() {
      this.$router.back();
    },
  },
};
</script>

<style lang="scss">
.ticket-create {
  flex: 1;
  max-width: 1253px;
  margin: auto;

  .card-wrapper {
    background-color: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 1px rgba(var(--vs-primary), 0.15);
    display: flex;
    flex-direction: column;
    padding: 20px;
    margin-bottom: 15px;
  }

  .button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 30px 0 10px;
  }
}
</style>

